import {createSelector} from 'reselect';

export const allQCDHistory =  (state) => state ? state : {};

export const getAllQCDHistory = createSelector(
  [allQCDHistory],
  (allHistory) => {
    return allHistory.QCDHistory.qcdHistory.sort(function(x, y){
      return x.tradeDate - y.tradeDate;
    }).reverse() ?? []
  }
);


